import * as React from 'react';
import {isOnCC, getJWT, checkJWT} from '@pluto-tv/lib-command-center-ts';
import Login from 'views/login/Login';
import {removeSplashPage} from 'helpers/removeSplashPage';

export default (): JSX.Element => {
  removeSplashPage();

  if (isOnCC()) {
    const jwt = getJWT() as string;
    if (!checkJWT(jwt)) {
      window.location.href = '/';
      return <></>;
    }
  }

  return <Login />;
};
